import React from 'react';
import { Dice1, Ticket, Key, List } from 'lucide-react';

/**
 * Компонент для отображения пресетов генератора случайных чисел
 */
const GeneratorPresets = ({ presets, applyPreset }) => {
  // Функция для получения иконки по идентификатору
  const getIconComponent = (iconId) => {
    switch (iconId) {
      case 'dice':
        return <Dice1 />;
      case 'ticket':
        return <Ticket />;
      case 'key':
        return <Key />;
      case 'list':
        return <List />;
      default:
        return <Dice1 />;
    }
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm p-5 mb-6">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
        Готовые шаблоны
      </h3>
      
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 gap-3">
        {presets.map((preset) => (
          <button
            key={preset.id}
            onClick={() => applyPreset(preset.id)}
            className="flex flex-col items-center bg-gray-50 dark:bg-gray-700/30 rounded-lg p-3 border border-gray-200 dark:border-gray-700 hover:bg-indigo-50 dark:hover:bg-indigo-900/20 hover:border-indigo-200 dark:hover:border-indigo-800 transition-colors"
          >
            <div className="w-10 h-10 flex items-center justify-center bg-indigo-100 dark:bg-indigo-900/50 rounded-full text-indigo-600 dark:text-indigo-400 mb-2">
              {getIconComponent(preset.icon)}
            </div>
            <span className="text-sm font-medium text-gray-900 dark:text-white">
              {preset.name}
            </span>
            <span className="text-xs text-gray-500 dark:text-gray-400 mt-1">
              {getPresetDescription(preset)}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

// Функция для получения краткого описания пресета
const getPresetDescription = (preset) => {
  const { config } = preset;
  
  if (preset.id === 'lottery') {
    return 'Числа для лотереи';
  }
  
  if (preset.id === 'dice') {
    return 'Имитация броска кубика';
  }
  
  if (preset.id === 'password') {
    return 'Генерация цифрового пароля';
  }
  
  if (preset.id === 'loto') {
    return 'Для игры в лото';
  }
  
  if (preset.id === 'lottery-multi') {
    return 'Комбинированная лотерея';
  }
  
  if (preset.id === 'custom-range') {
    return 'Разные диапазоны чисел';
  }
  
  // Общее описание для остальных
  return `${config.min}-${config.max}, ${config.count} чисел`;
};

export default GeneratorPresets;